import { graphql, type DocumentType } from 'app/generated/gql'

export const OPS_USAGE_COST_METRICS_QUERY = graphql(`
  query OpsUsageCostMetrics($input: UsageCostInput!) {
    opsUsageCostMetrics(input: $input) {
      summary {
        totalCostUsd
        voiceCalls
        smsConversations
        voiceMinutes
        totalTokensInput
        totalTokensOutput
        avgCostPerVoiceCall
        avgCostPerSmsConversation
        telephonyCostUsd
        elevenLabsLlmUsd
        elevenLabsPlatformUsd
        elevenLabsTotalUsd
        smsLlmCostUsd
        smsCarrierCostUsd
      }
      buckets {
        date
        voiceCalls
        smsConversations
        voiceCostUsd
        smsCostUsd
        voiceMinutes
        tokensInput
        tokensOutput
      }
      locations {
        locationId
        locationName
        workspaceName
        voiceCalls
        smsConversations
        totalCostUsd
        voiceCostUsd
        smsCostUsd
        avgCostPerInteraction
      }
      voiceOutcomes {
        key
        count
      }
      voiceTransferredCalls
      smsToolCalls {
        key
        count
      }
      avgSmsLatencyMs
    }
  }
`)

export const OPS_USAGE_COST_VOICE_CALLS_QUERY = graphql(`
  query OpsUsageCostVoiceCalls($input: UsageCostDetailInput!, $sort: SortInput) {
    opsUsageCostVoiceCalls(input: $input, sort: $sort) {
      hits {
        callId
        callDate
        callerPhone
        status
        transferred
        durationSeconds
        telephonyCostUsd
        elevenLabsAsrUsd
        elevenLabsTtsUsd
        elevenLabsLlmUsd
        elevenLabsPlatformUsd
        elevenLabsTotalUsd
        llmInputTokens
        llmOutputTokens
        totalCostUsd
      }
      total
      page
    }
  }
`)

export const OPS_USAGE_COST_SMS_THREADS_QUERY = graphql(`
  query OpsUsageCostSmsThreads($input: UsageCostDetailInput!) {
    opsUsageCostSmsThreads(input: $input) {
      hits {
        threadId
        contactId
        turns
        firstTurnDate
        lastTurnDate
        tokensInput
        tokensOutput
        llmCostUsd
        carrierCostUsd
        totalCostUsd
        avgLatencyMs
      }
      total
      page
    }
  }
`)

export type UsageCostQueryData = DocumentType<typeof OPS_USAGE_COST_METRICS_QUERY>[`opsUsageCostMetrics`]
export type UsageCostLocationRow = UsageCostQueryData[`locations`][number]
export type UsageCostVoiceCallRow = DocumentType<
  typeof OPS_USAGE_COST_VOICE_CALLS_QUERY
>[`opsUsageCostVoiceCalls`][`hits`][number]
export type UsageCostSmsThreadRow = DocumentType<
  typeof OPS_USAGE_COST_SMS_THREADS_QUERY
>[`opsUsageCostSmsThreads`][`hits`][number]
